import { defineMessages } from 'react-intl';

import { EVENT_TYPE } from '../../model/events';

export default defineMessages<EVENT_TYPE>({
  COMMENTED: {
    defaultMessage: 'Commented on',
    description: 'action taken on this object - comment added',
    id: 'uchi.eventTypeMessage.commented',
  },
  CREATED: {
    defaultMessage: 'Created',
    description: 'action taken on this object - initially created',
    id: 'uchi.eventTypeMessage.created',
  },
  EDITED: {
    defaultMessage: 'Edited',
    description: 'action taken on this object - edited',
    id: 'uchi.eventTypeMessage.edited',
  },
  PUBLISHED: {
    defaultMessage: 'Published',
    description: 'action taken on this object - published',
    id: 'uchi.eventTypeMessage.published',
  },
  UPDATED: {
    defaultMessage: 'Edited',
    description: 'action taken on this object - edited',
    id: 'uchi.eventTypeMessage.updated',
  },
  VIEWED: {
    defaultMessage: 'Viewed',
    description: 'action taken on this object - viewed',
    id: 'uchi.eventTypeMessage.viewed',
  },
});
